import Image from '../../assets/images/no-strategy-image.png';
import { Box, Typography } from '@mui/material';

export const EmptyList = ({ message }: { message: string }) => {
  const texts = message.split(/\r\n|\r|\n/g);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(60vh - 150px)',
      }}
    >
      <img src={Image} alt='no strategy' style={{ marginBottom: '20px' }} />

      {texts.map((text, i) => {
        return (
          <Typography
            key={i}
            sx={{
              color: '#655C68',
              fontSize: '16px',
              fontWeight: '600',
              lineHeight: '19px',
              textAlign: 'center',
            }}
          >
            {text}
          </Typography>
        );
      })}
    </Box>
  );
};
